import { render } from "./AllSkuView.vue?vue&type=template&id=2fd3e1eb"
import script from "./AllSkuView.vue?vue&type=script&lang=js"
export * from "./AllSkuView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__